import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const CarrMobili: AnaColumn[] = [
    {
      configuration:
      {
        titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
        titleForm: 'descrizioneSoggetto - $descrizioneSede',
  
        breadcrumbCaption: 'Carrozzerie Mobili',
        idBreadcrumbGroup: 'AlboCategoria',
  
        campoTitle: ['descrizioneSede', 'descrizioneSoggetto'],
        service: 'AlboCarrozzeriaMobile',
        api: 'AlboCarrozzeriaMobile',
        filterList: '?idAlboCategoria=$idAlboCategoria',
        filterEditor: '/$',
        helpDoc: 'CarrozzerieMobili.html',
        idTabRif:[
          {
            key: 'idAlboCategoria',
            value: 'idAlboCategoria'
          }
        ],
        queryFilter: [{
          key: 'idAlboCategoria',
          value: 'idAlboCategoria'
        },
        
      ],
        formType: 'simple',
        masterKey: 'id',
        nCol: 1,

        toolbarSettings: {
          service: 'alboCategoria',
         
  
        }
  
  
  
      }
  
    },
    
    {
      itemType: "group", colCount: "1", class: "col-12", caption: "Elenco Carrozzerie Mobili",groupDataField:'ElencoCarrozzerieMobili', data: [
        
        {
          type: 'campoSpecial', dataField: "idCarrozzeriaAlboGestore", caption: "Tipo Carrozzeria", editorType: "dxSelectBox",
          maxLength: '15', width: 25 * aspect, maxSize: 15,
          class: "required", validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          lista: {
            dataSource: 'CarrozzeriaAlboGestore',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: false,
  
          }
        },
       
  
      ]
    },

    {
      itemType: "group", caption: 'EER autorizzati Car.Mobili', colCount: "1", class: "col-12",
      data: [
        {
          showInColumnChooser:true,allowHiding:false,
          type: 'campoGriglia', labelVisible: false, colSpan: "1", dataField: 'listaCer',
          caption:'Lista EER',         
          colVisible: true,
         
          formGrid: {
            service: 'listaCer',
            api: '',
            remoteOperation: false,
            queryString: '',
            isEditable: true,
            isEditableNewRow: true,
            isEditableEditRow: true,
            isEditableDeleteRow: true,
            showToolbarTop: true,
            tableHeight: 350,
            tableWidth: 990,
            showFilter: false,
            selectionRowMode: 'none',  // 'single' | 'detail' | 'multiple';
            idTable: 'listaCer',
            isSearchable: false,
            toolbarCustomButtons:[
              
              {
                id: 'CopiaCerDaAlboCategoria',
                name: 'Copia elenco EER',
                text: 'Copia EER dalla Categoria Albo',
                icon: 'glyphicon mdi mdi-playlist-plus',
                disabled: false,
                visible: true,
                widget: 'button'
              },
              {
                id: 'CopiaCerDaAlboCarrozzeria',
                name: 'Copia elenco EER',
                text: 'Copia EER da altra Carrozzeria Mobile',
                icon: 'glyphicon mdi mdi-playlist-plus',
                disabled: false,
                visible: true,
                widget: 'button'
              },
              {
                id: 'incollaCer',
                name: 'Incolla lista EER',
                text: 'Incolla lista E.E.R.',
                icon: 'dx-icon-paste',
                disabled: false,
                visible: true,
                widget: 'button'
              },
           
          ]
            /* Continua da qui */
          }
  
         /*  dynamic: {  
            dataSource: '',
            service: 'listaCer',
            autocomplete: false,
            valueExpr: '',

            displayExpr: 'id',
            caption: "",  
            componentType: 'dynamicGrid',
            formGrid: {
              service: 'listaCer',
              api: '',
              remoteOperation: false,
              queryString: '',
              isEditable: true,
              isEditableNewRow: true,
              isEditableEditRow: true,
              isEditableDeleteRow: true,
              showToolbarTop: true,
              tableHeight: 350,
              tableWidth: 1000,
              showFilter: false,
              selectionRowMode: 'none',  // 'single' | 'detail' | 'multiple';
              idTable: 'listaCer',
              isSearchable: false
    
            }
    
            settingGrid: {
              campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
              keyUnique: '',
              masterKey: 'id',
              mode: 'cell',
              height:400,
              remoteOperations: false, //Abilitato per il salvataggio edit e delete
              hoverStateEnabled: true,
              rowAlternationEnabled: true,
              repaintChangesOnly: true,
              allowUpdating: true,
              allowDeleting: true,
              allowAdding: false,
              searchAndSelect: false, //Cerca Valore e seleziona
              enabledCustomButton:true,
              showFilterSearch:false,
              toolbarButtons:[
                { 
                   name: 'Copia elenco EER',
                   hint: "Copia gli EER dalla Categoria Albo ",
                   icon: "glyphicon mdi mdi-playlist-plus",
                   location: 'after',
                   text: 'Copia EER dalla Categoria Albo',
                   type: 'icon',
                   event: 'CopiaCerDaAlboCategoria',
                   disabled: false,
                   class:'',
                   accesskey:'C',
                   visible:true
                },
                { 
                  name: 'Copia elenco EER',
                  hint: "Copia gli EER di un'altra carrozzeria",
                  icon: "glyphicon mdi mdi-playlist-plus",
                  location: 'after',
                  text: 'Copia EER da altra Carrozzeria Mobile',
                  type: 'icon',
                  event: 'CopiaCerDaAlboCarrozzeria',
                  disabled: false,
                  class:'',
                  accesskey:'C',
                  visible:true
               }
               ]
            }
          } */
        },
  
      ]
  
    },
  ]